module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAOBAMAAAC88gOBAAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9kKFhU3NG15wr8AAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAFVBMVEX4+MiAeHCQYGD4WIj4wLD4+Pj///9xhfjAAAAAAXRSTlMAQObYZgAAAAFiS0dEBmFmuH0AAABuSURBVAgdXcHBCQJQDETBIDYQHrmLVhDj3gVtYA/pvxXP35m4fg/v+MzhFfMntMhCLBZLKO0qVGmr0iHsTlukVWRoszyFmN1iQkkXQoyrmBBjIYStwiGmjOhNKzejmc5pJskmifkTjzk843I/3H72iihhKE0/6QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/types/Psychic.png
// module id = 171
// module chunks = 0